import React from "react";

interface DividerProps {
}

const Divider:React.FC<DividerProps> = ({}) => {
    return (
        <div style={{height: 2, width:"100%", background: "#000", opacity:.05, marginTop: "16px", marginBottom:"16px"}}></div>
    )
}

export default Divider;